import { render } from "./ComponenteCalderasElectricas.vue?vue&type=template&id=6422e1ab&scoped=true"
import script from "./ComponenteCalderasElectricas.vue?vue&type=script&lang=js"
export * from "./ComponenteCalderasElectricas.vue?vue&type=script&lang=js"

import "./ComponenteCalderasElectricas.vue?vue&type=style&index=0&id=6422e1ab&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6422e1ab"]])

export default __exports__